<section class="access-restricted-page">
  <div class="access-restricted-card">
    <div class="status-icon">
      <i class="fa-solid fa-lock"></i>
    </div>

    <h1>Access unavailable</h1>
    <p class="message">
      Your FIU is currently inactive or archived, so you can no longer access the platform.
    </p>
    <p class="guidance">
      Please contact Support or your System Administrator if you believe this is incorrect.
    </p>

    <div class="actions">
      <a class="primary-action" href="mailto:{{supportEmailAddress}}">
        <i class="fa-solid fa-envelope"></i>
        Contact Support
      </a>
      <button class="secondary-action" type="button" (click)="logout()">
        Sign Out
      </button>
    </div>
  </div>
</section>
